import {
  validateAlpha,
  validateAlphaNumeric,
  validateBirthDate,
  validateCURP,
  validatePhoneNumber,
  validatePropertyNumber,
  validateRFC,
  validateStreet,
  validateZipCode,
} from "../generalValidators.ts";

export const legalRepFormValidators = {
  first_name: validateAlpha,
  second_name: validateAlpha,
  first_last_name: validateAlpha,
  second_last_name: validateAlpha,
  country: validateAlpha,
  city: validateAlpha,
  state: validateAlpha,
  birth_date: validateBirthDate,
  rfc: validateRFC,
  curp: validateCURP,
  street: validateStreet,
  exterior_number: validatePropertyNumber,
  interior_number: validatePropertyNumber,
  neighborhood: validateAlphaNumeric,
  postal_code: validateZipCode,
  municipality: validateAlpha,
  current_state: validateAlpha,
  cellphone: validatePhoneNumber,
};
